import KYCActionTypes from "./types";
import { extractKYCdata } from "store/helpers";

const USER_INITIAL_STATE = {
    kycData: {
        Phone: [],
        Birthday: "1995-01-01",
        Address: [],
        BankAccount: [],
        Identification: {},
    },
    kycFormData: {
        identification: {},
        personal: {},
        bankAccount: {},
    },
    sparkasseRegistrierungsdaten: null,
    hasUserInitiated: false,
    isUserKYCed: false,
    isSubmittingKYC: false,
    isSubmittingKycSuccess: false,
    isSubmittingReKyc: false,
    isSubmittingReKycSuccess: false,
    reKYC: false,
    providerData: {},
    isKYCServerError: false,
    statusKYC: "",
};
const INITIAL_STATE = {
    ...USER_INITIAL_STATE,
    adminSelectedUser: {
        ...USER_INITIAL_STATE,
    },
};

const kycReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        //Combined as return is same, split if need to change singularly.
        case KYCActionTypes.SET_REKYC_START:
            return {
                ...state,
                isSubmittingReKyc: true,
                isSubmittingReKycSuccess: false,
                error: null,
            };
        case KYCActionTypes.FETCH_KYC_START:
        case KYCActionTypes.SET_KYC_START:
            return {
                ...state,
                isSubmittingKYC: true,
                isSubmittingKycSuccess: false,
                error: null,
            };
        case KYCActionTypes.SET_KYC_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmittingKYC: false,
                isSubmittingKycSuccess: payload.isSubmittingKycSuccess,
                kycData: payload.kycData || state.kycData,
                kycFormData: payload.kycFormData || state.kycFormData,
                hasUserInitiated: payload.hasUserInitiated || state.hasUserInitiated,
            };
        case KYCActionTypes.FETCH_KYC_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmittingKYC: false,
                kycData: payload.kycData || state.kycData,
                kycFormData: payload.kycFormData || state.kycFormData,
                hasUserInitiated: payload.hasUserInitiated || state.hasUserInitiated,
            };
        case KYCActionTypes.FETCH_KYC_FROM_PROVIDER_SUCCESS:
            return {
                ...state,
                isUserKYCed: payload.isUserKYCed,
                providerData: payload.providerData,
            };
        case KYCActionTypes.SET_REKYC_SUCCESS:
            return {
                ...state,
                isSubmittingReKyc: false,
                ...payload,
            };
        case KYCActionTypes.SET_REKYC_FAILURE:
            return {
                ...state,
                isSubmittingReKyc: false,
                isSubmittingReKycSuccess: false,
                error: null,
            };
        case KYCActionTypes.FETCH_REKYC_SUCCESS:
            return {
                ...state,
                isLoading: false,
                reKYC: payload.reKYC,
            };

        case KYCActionTypes.FETCH_KYC_STATUS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                statusKYC: payload.statusKyc,
            };

        case KYCActionTypes.FETCH_KYC_SERVER_ERROR:
            return {
                ...state,
                isKYCServerError: payload,
            };
        //Combined as return is same, split if need to change singularly.
        case KYCActionTypes.SET_KYC_FAILURE:
        case KYCActionTypes.FETCH_KYC_FAILURE:
        case KYCActionTypes.FETCH_KYC_FROM_PROVIDER_FAILURE:
        case KYCActionTypes.FETCH_KYC_STATUS_FAILURE:
            return {
                ...state,
                error: payload === "user not found" ? false : payload,
                isLoading: false,
                isSubmittingKYC: false,
            };
        case KYCActionTypes.UPDATE_KYC_FORM_DATA:
            return {
                ...state,
                isLoading: false,
                isSubmittingKYC: false,
                kycFormData: {
                    ...state.kycFormData,
                    identification: {
                        ...state.kycFormData?.identification,
                        ...payload.identification,
                    },
                    personal: {
                        ...state.kycFormData?.personal,
                        ...payload.personal,
                    },
                },
            };
        case KYCActionTypes.RESET_KYC_FORM_DATA:
            const kycFormData = extractKYCdata(state.kycData);
            return {
                ...state,
                kycFormData: kycFormData,
            };

        //
        // ADMIN
        //
        case KYCActionTypes.FETCH_KYC_START_ADMIN:
            return {
                ...state,
                adminSelectedUser: {
                    ...state?.adminSelectedUser,
                    isLoading: true,
                    kycData: {},
                    kycFormData: {},
                    isUserKYCed: false,
                    hasUserInitiated: false,
                    reKYC: false,
                    providerData: {},
                },
            };
        case KYCActionTypes.FETCH_KYC_SUCCESS_ADMIN:
            return {
                ...state,
                adminSelectedUser: {
                    ...state.adminSelectedUser,
                    isLoading: false,
                    kycData: payload.kycData || state.kycData,
                    kycFormData: payload.kycFormData || state.kycFormData,
                    isUserKYCed: payload.isUserKYCed,
                    hasUserInitiated: payload.hasUserInitiated || state.hasUserInitiated,
                    reKYC: payload.reKYC,
                    providerData: payload.providerData,
                },
            };
        case KYCActionTypes.FETCH_KYC_FAILURE_ADMIN:
            return {
                ...state,
                adminSelectedUser: {
                    ...state?.adminSelectedUser,
                    isLoading: false,
                    error: payload,
                },
            };
        case KYCActionTypes.FETCH_REKYC_SUCCESS_ADMIN:
            return {
                ...state,
                adminSelectedUser: {
                    ...state?.adminSelectedUser,
                    isLoading: false,
                    reKYC: payload.reKYC,
                },
            };

        case KYCActionTypes.UPDATE_KYC_ADMIN:
            return {
                ...state,
                adminSelectedUser: {
                    ...state?.adminSelectedUser,
                    isUserKYCed: payload.isUserKYCed,
                    hasUserInitiated: payload.hasUserInitiated,
                    Provider: payload.Provider,
                    reKYC: payload.reKYC,
                },
            };

        default:
            return state;
    }
};

export default kycReducer;
